import { Component, DestroyRef, HostListener, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Project } from '@apps/projects/projects.state';
import { Store, select } from '@ngrx/store';
import { selectUser } from '@platform/platform.selectors';
import { NavigationService } from '@platform/shared/navigation.service';
import { RootState } from '@root/app.state';
import { Observable, filter, map, shareReplay, startWith } from 'rxjs';
import { ItemsResponseDto } from '@platform/shared/items-response.dto';
import { LoadingService, provideLoadingService } from '@platform/shared/loading.service';
import { ProjectsService } from '@apps/projects/projects.service';

const ROWS_TO_DISPLAY = 6;

@Component({
  selector: 'app-project-widget',
  templateUrl: './project-widget.component.html',
  styleUrls: ['./project-widget.component.scss'],
  providers: [provideLoadingService()],
})
export class ProjectWidgetComponent implements OnInit {
  @Input({ required: true }) customerSpaceId!: string;
  navigation = inject(NavigationService);
  projectItems$: Observable<Project[]>;
  totalCount$: Observable<number>;
  isInternalUser: boolean;
  showProjectNumbersDiv: boolean[];
  showOverlay: boolean;

  private projectsResponse$!: Observable<ItemsResponseDto<Project>>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private store$: Store<RootState>,
    public loadingService: LoadingService,
    private projectsService: ProjectsService,
  ) {
    this.isInternalUser = false;
    this.showOverlay = false;
    this.showProjectNumbersDiv = [];
  }

  @HostListener('document:click')
  click() {
    this.hideOverlayAndDiv();
  }

  ngOnInit(): void {
    this.projectsResponse$ = this.loadingService.showLoadingUntilCompleted(
      this.projectsService.getCustomerSpaceProjectsForWidget(this.customerSpaceId, ROWS_TO_DISPLAY).pipe(
        startWith({
          items: [],
          totalCount: 0,
        }),
        shareReplay(1),
      ),
    );

    this.projectItems$ = this.projectsResponse$.pipe(map((response) => response.items));
    this.totalCount$ = this.projectsResponse$.pipe(map((response) => response.totalCount));

    this.store$
      .pipe(
        select(selectUser),
        filter((x) => x.data !== null),
        map((x) => x.data),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((x) => {
        this.isInternalUser = x.isInternal;
      });
  }

  onProjectNumbersClick(i: number) {
    alert(i);
    if (this.isInternalUser) {
      if (!this.showProjectNumbersDiv[i]) {
        this.showDivWithOverlay(i);
      }
    }
  }

  showDivWithOverlay(i: number) {
    this.showProjectNumbersDiv[i] = true;
    this.showOverlay = true;
  }

  hideOverlayAndDiv() {
    this.showProjectNumbersDiv.fill(false);
    this.showOverlay = false;
  }
}
